import React, {useState, useEffect} from 'react';
import {  Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import OperationDatatable from './OperationDatatable';


const OperationModalWithDatatable = (props) => {
   
    const [t] = useTranslation();
    const [show, setShow] = useState(false);            
   // const [recordId, setRecordId ] = useState();    
  

    const handleCallback = (id) => {
        setShow(false);     
        props.parentCallback(false,id);      
    };
     
    const hideModal = () => {
      setShow(false);         
    };
   
    useEffect(() => {
        setShow(props.modal);
    }, [props.modal])

    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                //  centered
                  size="lg"                       //xl                 
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{t('workOrder.label.operations')}</Modal.Title>
                  </Modal.Header>
                    <Modal.Body>

                        <OperationDatatable 
                          parentCallback={handleCallback}    
                          modalShow={show}   
                        />          
             
                    </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default OperationModalWithDatatable;


 